export default {
  "content": "<path fill=\"#fff\" d=\"M14.788 5.117c.651.093 1.252.65 1.464 1.44.211.79-.03 1.573-.548 1.979l1.119 4.177c.098.365-.059.762-.398 1.004a1.124 1.124 0 01-1.148.095l-1.711-.89c-1.873-.955-4.118-1.145-6.253-.573l-.274.074.97 3.622c.135.5-.206 1.026-.763 1.175l-2.012.54c-.556.148-1.115-.136-1.249-.637l-.97-3.622c-1.112.298-2.23-.273-2.498-1.272l-.728-2.717c-.268-.999.416-2.052 1.527-2.35L5.614 6.01c2.135-.572 3.978-1.884 5.123-3.646L11.78.76c.217-.335.63-.53 1.042-.49.415.04.748.304.847.67l1.119 4.177zM6.1 7.822l-.274.073.728 2.716.274-.073c2.509-.672 5.146-.475 7.4.543l-1.99-7.43C10.794 5.66 8.608 7.148 6.1 7.82z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "17",
    "height": "18",
    "fill": "none",
    "viewBox": "0 0 17 18"
  }
};